import { AfterViewInit, Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import JsBarcode from 'jsbarcode';

@Component({
  selector: 'app-mobilebarcode',
  standalone: true,
  imports: [],
  templateUrl: './mobilebarcode.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './mobilebarcode.component.css'
})
export class MobilebarcodeComponent implements AfterViewInit {
  @ViewChild('barcodeElement') barcodeElement!: ElementRef;
  @Input()  barcodeValue = '/L3V7REQ';
constructor() { }

  ngOnInit(): void { }
  ngAfterViewInit(): void {
    this.generateBarcode();
  }

  generateBarcode(): void {
    JsBarcode(this.barcodeElement.nativeElement, this.barcodeValue, {
      format: "CODE39",
      width: 2,
      height: 100,
      displayValue: true,
      fontSize: 20,
      textAlign: "center",
      textPosition: "bottom",
      textMargin: 5,
      font: "monospace",
      background: "#ffffff",
      lineColor: "#000000"
    });
  }

  copyBarcode(): void {
    navigator.clipboard.writeText(this.barcodeValue)
      .then(() => {
        alert('條碼已複製到剪貼簿！');
      })
      .catch(err => {
        console.error('複製失敗:', err);
        alert('複製失敗，請手動複製。');
      });
  }
}
